import { z } from 'zod';

export const sequentialSchemeSchema = z.object({
  kind: z.literal('sequential'),
  start: z.number().int().min(1),
});

// Row-encoded: a spot's decade is its column, its last digit its row. See §6.
export const rowEncodedSchemeSchema = z.object({
  kind: z.literal('row-encoded'),
  colsPerSide: z.number().int().min(1),
  step: z.number().int().min(1),
  rowOffset: z.number().int(),
  zeroDecadeStart: z.number().int().min(1),
});

export const numberingSchemeSchema = z.discriminatedUnion('kind', [
  sequentialSchemeSchema,
  rowEncodedSchemeSchema,
]);

export type NumberingScheme = z.infer<typeof numberingSchemeSchema>;

export const spotPlacementSchema = z.object({
  side: z.number().int().min(0),
  col: z.number().int().min(0),
  row: z.number().int().min(1),
  ordinal: z.number().int().min(0),
});

export type SpotPlacement = z.infer<typeof spotPlacementSchema>;

// The zero decade cannot encode a zero, so it counts from zeroDecadeStart instead.
export function spotNumber(scheme: NumberingScheme, at: SpotPlacement): number {
  if (scheme.kind === 'sequential') return scheme.start + at.ordinal;
  const decade = (at.side * scheme.colsPerSide + at.col) * scheme.step;
  if (decade === 0) return scheme.zeroDecadeStart + at.row - 1;
  return decade + at.row + scheme.rowOffset;
}
